<div class="iframe__container">
    <iframe class="chat__charts"  [src]="dynamicUrl | trustUrl"></iframe>
</div>